export default {
    MANUAL: 1,
    INCONSISTENCIA: 2,
    CADASTRO_DESATUALIZADO: 3,
}